import { SET_COMPANIES_LIST } from "../actions/CompanyListActions";

const initialState = {
    companies: []
};

export default function companyListReducer(state = initialState, action) {
    switch (action.type) {
        case SET_COMPANIES_LIST:
            return {
                ...state,
                companies: action.payload
            };

        default:
            return state;
    }
}